(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cp-photo-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cp-photo-wall')) {
    customElements.define('cp-photo-wall', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          button.setAttribute('aria-pressed', String(paused));
          button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
        }, {signal: this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-promo-timer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cp-promo-timer')){
 customElements.define('cp-promo-timer',class extends HTMLElement{
  connectedCallback(){
   clearInterval(this.timer);
   this.units=['hours','minutes','seconds'].map(unit=>this.querySelector(`[data-${unit}]`));
   if(this.units.some(unit=>!unit))return;
   this.repeating=this.dataset.mode==='public_demo';
   const configuredSeconds=Number(this.dataset.seconds);
   this.duration=Math.max(this.repeating?1:0,Number.isFinite(configuredSeconds)?Math.floor(configuredSeconds):1654)*1000;
   const now=Date.now();
   let savedEnd=this.repeating?this.end:0;
   if(this.repeating){
    try{savedEnd=Number(sessionStorage.getItem(this.dataset.storageKey))||savedEnd;}catch(e){}
   }
   this.end=Number.isFinite(savedEnd)&&savedEnd>0&&savedEnd<=now+this.duration?savedEnd:now+this.duration;
   this.persistEnd();
   this.tick();
   if(this.repeating||this.end>now)this.timer=setInterval(()=>this.tick(),1000);
  }
  persistEnd(){
   if(!this.repeating)return;
   try{sessionStorage.setItem(this.dataset.storageKey,String(this.end));}catch(e){}
  }
  tick(){
   const now=Date.now();
   if(this.repeating&&now>=this.end){
    this.end+=(Math.floor((now-this.end)/this.duration)+1)*this.duration;
    this.persistEnd();
   }
   const remaining=Math.max(0,Math.ceil((this.end-now)/1000));
   const values=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60];
   this.units.forEach((unit,index)=>{unit.textContent=String(values[index]).padStart(2,'0');});
   if(remaining===0)clearInterval(this.timer);
  }
  disconnectedCallback(){clearInterval(this.timer);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-reference-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cp-reference-tabs')) {
  customElements.define('cp-reference-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; if (i !== index) panels[i].querySelectorAll('video').forEach(video => video.pause()); });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(next, true); }
        });
      });
      this.addEventListener('shopify:block:select', event => { const index = panels.findIndex(panel => panel.contains(event.target)); if (index >= 0) activate(index); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-social-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cp-social-carousel')) {
  customElements.define('cp-social-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track=this.querySelector('.cp-social-stories__grid');
      this.toggle=this.querySelector('[data-toggle]');
      this.reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.dataset.autoplay!=='true'||this.reduced.matches;
      this.visible=false;this.until=0;this.hovered=false;this.focused=false;
      this.abort=new AbortController();const opts={signal:this.abort.signal};
      const hold=()=>{this.until=Date.now()+8000;};
      this.track.addEventListener('pointerdown',hold,opts);
      this.track.addEventListener('wheel',hold,{...opts,passive:true});
      this.track.addEventListener('mouseenter',()=>{this.hovered=true;},opts);
      this.track.addEventListener('mouseleave',()=>{this.hovered=false;},opts);
      this.track.addEventListener('focusin',()=>{this.focused=true;},opts);
      this.track.addEventListener('focusout',()=>{this.focused=false;},opts);
      this.querySelector('[data-prev]').addEventListener('click',()=>{hold();this.move(-1);},opts);
      this.querySelector('[data-next]').addEventListener('click',()=>{hold();this.move(1);},opts);
      this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.label();},opts);
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches){this.paused=true;this.label();}},opts);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;},{threshold:0.25});this.observer.observe(this.track);
      this.timer=setInterval(()=>{if(!this.paused&&this.visible&&!this.hovered&&!this.focused&&!document.hidden&&Date.now()>this.until)this.move(1);},Number(this.dataset.interval)||3500);
      this.label();
    }
    label(){this.toggle.textContent=this.paused?this.toggle.dataset.play:this.toggle.dataset.pause;}
    move(direction){
      const step=this.track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);
      const max=this.track.scrollWidth-this.track.clientWidth;
      let target=this.track.scrollLeft+direction*step;
      if(direction>0&&this.track.scrollLeft>=max-3)target=0;
      if(direction<0&&this.track.scrollLeft<=3)target=max;
      this.track.scrollTo({left:Math.max(0,Math.min(max,target)),behavior:this.reduced.matches?'instant':'smooth'});
    }
    disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-study-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const button = event.target.closest('.cp-study-reviews__controls button');
  if (!button) return;
  const rail = button.closest('.cp-study-reviews').querySelector('.cp-study-reviews__rail');
  const card = rail.querySelector('article');
  if (card) rail.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + 22), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cp-video-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const play = event.target.closest('.cp-video-review__play');
  if (play) {
    const video = play.parentElement.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.cp-video-reviews video').forEach(other => { if (other !== video) other.pause(); });
    video.play().then(() => { play.hidden = true; video.focus(); }).catch(() => { video.controls = true; play.hidden = true; });
    video.addEventListener('ended', () => { play.hidden = false; }, {once:true});
  }
  const arrow = event.target.closest('.cp-video-reviews__controls button');
  if (arrow) {
    const rail = arrow.closest('.cp-video-reviews').querySelector('.cp-video-reviews__rail');
    rail.scrollBy({left: Number(arrow.dataset.shift) * (rail.querySelector('article').getBoundingClientRect().width + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
